import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

function PayAdmissionChallanModal({
  title,
  onClose,
  payAdmissionChallan,
  admissionModalData,
}) {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
    reset,
  } = useForm({
    defaultValues: {
      bankName: "Cash",
      accountNo: "",
      receiptNo: admissionModalData?.receiptNo || "",
      remarks: "Admission challan paid",
    },
  });

  useEffect(() => {
    if (admissionModalData) {
      reset({
        bankName: "Cash",
        accountNo: "",
        receiptNo: admissionModalData.receiptNo || "",
        remarks: "Admission challan paid",
      });
    }
  }, [admissionModalData, reset]);

  const selectedBank = watch("bankName");

  const [isLoading, setIsLoading] = useState(false);

  if (!admissionModalData) {
    return null;
  }

  const saveData = async (formData) => {
    setIsLoading(true);
    try {
      const formWithAdditionalData = {
        ...formData,
        id: admissionModalData.admissionVoucherId,
        voucherNo: admissionModalData.voucherNo,
        studentFirstRegistrationId:
          admissionModalData.studentFirstRegistrationId,
      };

      await payAdmissionChallan(formWithAdditionalData);
    } catch (error) {
      console.error("Error processing payment:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <div className="row fs-9">
                  <div className="col-md-6">
                    <div>
                      <label className="fw-bold">Student Name:</label>
                      <span className="ms-1">
                        {admissionModalData.studentName}
                      </span>
                    </div>
                    <div>
                      <label className="fw-bold">Challan No:</label>
                      <span className="ms-1">
                        {admissionModalData.voucherNo}
                      </span>
                    </div>
                    <div>
                      <label className="fw-bold">Email:</label>
                      <span className="ms-1">{admissionModalData.email}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mb-3 table-responsive">
                <table className="table table-bordered custom-table m-0">
                  <thead>
                    <tr>
                      <th className="fw-bold">Fee Type</th>
                      <th className="fw-bold">Fee Amount</th>
                      <th className="fw-bold">Discount Given</th>
                      {/* <th className="fw-bold">VAT</th> */}
                      <th className="fw-bold">Net Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {admissionModalData?.admissionVoucherDetailDto.length >
                    0 ? (
                      <>
                        {admissionModalData.admissionVoucherDetailDto.map(
                          (fee, index) => (
                            <tr key={index}>
                              <td>{fee.feeTypeName}</td>
                              <td>{fee.amount}</td>
                              <td>{fee.discount}</td>
                              {/* <td>{fee.vat}</td> */}
                              <td>{fee.netAmount}</td>
                            </tr>
                          ),
                        )}
                        <tr>
                          <td colSpan="3">
                            <strong>Total Amount</strong>
                          </td>
                          <td>
                            <strong>
                              {admissionModalData.admissionVoucherDetailDto.reduce(
                                (total, fee) => total + fee.netAmount,
                                0,
                              )}
                            </strong>
                          </td>
                        </tr>
                      </>
                    ) : null}
                  </tbody>
                </table>
              </div>

              <form onSubmit={handleSubmit(saveData)}>
                <div className="mb-5">
                  <div className="row fs-9 g-3">
                    <div className="col-md-3">
                      <label className="fw-bold">
                        Bank Name <span className="text-danger fs-9">*</span>
                      </label>
                      <select
                        {...register("bankName", {
                          required: "This field is required.",
                        })}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        <option value="Cash">Cash</option>
                        <option value="Bank Al Falah">Bank Al Falah</option>
                        <option value="Meezan Bank">Meezan Bank</option>
                        <option value="Habib Bank">Habib Bank</option>
                      </select>
                      {errors.bankName && (
                        <small className="text-danger">
                          {errors.bankName.message}
                        </small>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="fw-bold">
                        Account Number{" "}
                        <span className="text-danger fs-9">*</span>
                      </label>
                      <input
                        {...register("accountNo", {
                          required: selectedBank === "Cash" ? false : "This field is required.",
                        })}
                        type="text"
                        className="form-control"
                        disabled={selectedBank === "Cash"}
                      />
                      {errors.accountNo && selectedBank !== "Cash" && (
                        <small className="text-danger">
                          {errors.accountNo.message}
                        </small>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="fw-bold">
                        Receipt Number{" "}
                        <span className="text-danger fs-9">*</span>
                      </label>
                      <input
                        {...register("receiptNo", {
                          required: "This field is required.",
                        })}
                        type="text"
                        className="form-control"
                      />
                      {errors.receiptNo && (
                        <small className="text-danger">
                          {errors.receiptNo.message}
                        </small>
                      )}
                    </div>
                    <div className="col-md-3">
                      <label className="fw-bold">Remarks</label>
                      <input
                        {...register("remarks")}
                        type="text"
                        className="form-control"
                      />
                      {errors.remarks && (
                        <small className="text-danger">
                          {errors.remarks.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-2 justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-sm btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span
                        className="spinner-border spinner-custom-size me-1"
                        aria-hidden="true"
                      ></span>
                    ) : null}
                    <span role="status">Confirm Payment</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default PayAdmissionChallanModal;
